import { Form, Input, Modal } from 'antd'

import { PublisherService } from '@services/PublisherService'
import { useNotifications } from '@store/notifications'

interface Props {
    isOpen: boolean
    onClose: () => void
    refetch: () => Promise<void>
}

export const AddPublisherModal = ({ isOpen, onClose, refetch }: Props) => {
    const [form] = Form.useForm()
    const { showNotification } = useNotifications()

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields()
            await PublisherService.create(values)
            showNotification({ title: 'Publisher created successfully' })
            form.resetFields()
            onClose()
            refetch()
        } catch (error) {
            showNotification({ title: 'Error creating publisher', type: 'error' })
        }
    }

    return (
        <Modal title="Add Publisher" open={isOpen} onCancel={onClose} onOk={handleSubmit}>
            <Form form={form} layout="vertical">
                <Form.Item
                    name="name"
                    label="Name"
                    rules={[{ required: true, message: 'Please input publisher name!' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="country"
                    label="Country"
                    rules={[{ required: true, message: 'Please input country!' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item name="state" label="State">
                    <Input />
                </Form.Item>
                <Form.Item name="city" label="City">
                    <Input />
                </Form.Item>
                <Form.Item name="zipCode" label="Zip Code">
                    <Input />
                </Form.Item>
                <Form.Item name="address" label="Address">
                    <Input />
                </Form.Item>
                <Form.Item name="phone" label="Phone">
                    <Input />
                </Form.Item>
                <Form.Item name="email" label="Email">
                    <Input type="email" />
                </Form.Item>
            </Form>
        </Modal>
    )
}
